import './home-page.scss'
import { useLoadPageComponents, useLogger } from '@omnia/ui/src/lib'
import { OrderType } from '@vista-digital/ocapi-types/v1'
import { getOrder, getOrderSelections } from '@vista-digital/occ-domain'
import { type FC, useEffect } from 'react'
import HeroCarousel from '@/common/components/heroCarousel/HeroCarousel'
import { Meta } from '@/common/components/meta/Meta'
import { resetOrderStore } from '@/common/utils/resetOrderStore'
import { Grid } from '@/features/grid/Grid'
import { PageTitle } from '@/features/layout/pageTitle/PageTitle'
import { HomePageResponse } from './props'

export const HomePage: FC = () => {
    const logger = useLogger('HomePage')
    const { pageResponse, isPending } = useLoadPageComponents(new HomePageResponse())
    const order = getOrder()
    const selections = getOrderSelections()

    useEffect(() => {
        if ((order && order?.type !== OrderType.Standard) || selections?.subscription) {
            resetOrderStore()
        }
    }, [order, selections])

    logger.trace('Rendering', { pageResponse, isPending })

    if (isPending) {
        return null
    }

    return (
        <div className="home-page">
            <Meta {...pageResponse} />
            <PageTitle text={pageResponse.pageTitle} hide={pageResponse.hideTitle} />
            <HeroCarousel items={pageResponse.components.HeroCarousel} />
            <Grid rows={pageResponse.grid} />
        </div>
    )
}
